import {
  createMuiTheme,
  CssBaseline,
  Drawer,
  makeStyles,
  ThemeProvider,
} from "@material-ui/core";
import React from "react";
import Header from "../../../components/Admin/Header";
import red from "@material-ui/core/colors/red";

import MyDrawer from "../../../components/Admin/Drawer";
import Images from "./Images";
import { ImageProvider } from "../../../components/Image/ImageContext";
import { useStyles, theme } from "../theme.js";

const ImageAdminPage = (props) => {
  const classes = useStyles();

  return (
    <ImageProvider>
      <ThemeProvider theme={theme}>
        <Drawer
          className={classes.drawer}
          variant="permanent"
          classes={{
            paper: classes.drawerPaper,
          }}
          anchor="left"
        >
          <MyDrawer></MyDrawer>
        </Drawer>
        <div className={classes.adminMain}>
          <Header></Header>
          <Images></Images>
        </div>
        <CssBaseline></CssBaseline>
      </ThemeProvider>
    </ImageProvider>
  );
};

export default ImageAdminPage;
